/**
 * Loop through the provided plugins and kick them off!
 */
export default (plugins, params) => {
  plugins.forEach(plugin => {
    require(`./${plugin}.js`).default(params)
  })
}
